import type { Context, Config } from '@netlify/edge-functions';

export const MARKETING_OPT_OUT_FIELD_ID = 'marketing_opt_out';

// SOURCE: https://sonarsource.atlassian.net/browse/SONARSITE-2336
const GDPRCompliantCountries = [
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'CY', // Cyprus
  'CZ', // Czech Republic
  'DK', // Denmark
  'DE', // Germany
  'GR', // Greece
  'IT', // Italy
  'LT', // Lithuania
  'MT', // Malta
  'NL', // Netherlands
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'ES', // Spain
];

export default async (_: Request, context: Context) => {
  if (!context.geo.country?.name || !context.geo.country.code) {
    return;
  }

  const shouldHideMarketingOptOut = !GDPRCompliantCountries.includes(context.geo.country?.code);

  const currentResponse = await context.next();
  let responseBody = await currentResponse.text();
  responseBody = injectCountryDataIntoHtml(
    responseBody,
    context.geo.country?.name,
    context.geo.country?.code
  );

  if (shouldHideMarketingOptOut) {
    responseBody = hidemarketingOptOutInput(responseBody);
  }

  return new Response(responseBody, currentResponse);
};

function injectCountryDataIntoHtml(html: string, countryName?: string, countryCode?: string) {
  return html.replace(
    '<html ',
    `<html data-geo-country-name="${countryName}" data-geo-country-code="${countryCode}" `
  );
}

function hidemarketingOptOutInput(html: string) {
  return html.replace(
    '</head>',
    `<style>
      fieldset[name=${MARKETING_OPT_OUT_FIELD_ID}] {
        display: none;
      }
    </style>
    </head>`
  );
}

export const config: Config = {
  path: '/*',
  excludedPath: ['/*.*', '/api/*'],
  onError: 'bypass',
};
